import React, {useState} from "react";
import {Button, Row, Col, Modal, notification, Table, Icon} from "antd";
import Spinner from "../../spinner";
import {distributionCenterService} from "../../../services";
import InputField from "../../input-field";
import '../modals.css';
import i18n from "../../../i18n";


export default function ModalEditDistributionCenterOrderTimeSums({
                                                                   isShow, distCenterId,
                                                                   onCloseModal,
                                                                   name,
                                                                 }) {

  const [loadingContentModal, setLoadingContentModal] = useState(true);
  const [fieldsErrors, setFieldsErrors] = useState(null);

  const [timeAndSums, setTimeAndSums] = useState([]);

  const [time, setTime] = useState('');
  const [sum, setSum] = useState('');

  let bigButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px'
  };
  let smallButtonStyle = {
    width: '100%',
    height: '40px',
    background: '#2B3F63',
    position: 'static',
    borderRadius: '10px',
    marginTop: "31px"
  };
  let BackButtonStyle = {
    width: '190px',
    height: '40px',
    background: '#EB5757',
    position: 'static',
    borderRadius: '10px',
    marginBottom: "13px",
    marginTop: "13px"
  };

  if (isShow && loadingContentModal) {
    distributionCenterService.getOrderTimeSums(distCenterId)
      .then((response) => {
        const timeAndSumsData = response.map((item) => {
          return {
            hour: item.hour,
            sum: item.sum,
            id: item.id
          };
        });
        setTimeAndSums(timeAndSumsData);
        setLoadingContentModal(false);
      })
      .catch((error) => {
        setLoadingContentModal(false);
      });
  }

  const deleteOrderTimeSum = (id) => {
    distributionCenterService.deleteOrderTimeSum(id)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.deleteOrderTimeSum'),
          description: response.message,
        });
        setLoadingContentModal(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.deleteOrderTimeSum'),
          description: error.message,
        });
        setLoadingContentModal(true);
      })
  };

  // сохранение новых данных о РЦ
  const onClickAdd = () => {
    setLoadingContentModal(true);
    distributionCenterService.addOrderTimeSum(distCenterId, time, sum)
      .then((response) => {
        if (response.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.addOrderTimeSum'),
            description: response.message,
          });
          setFieldsErrors(null);
        } else {
          setFieldsErrors(response.errors);
        }
        setLoadingContentModal(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.addOrderTimeSum'),
          description: error,
        });
        setLoadingContentModal(true);
      });
  };

  const columns = [
    {
      title: i18n.t('modals.modalEditDistributionCenterOrderTimeSums.table.hour.title'),
      dataIndex: 'hour',
      key: 'hour',
      width: '35%',
    },
    {
      title: i18n.t('modals.modalEditDistributionCenterOrderTimeSums.table.sum.title'),
      dataIndex: 'sum',
      key: 'sum',
      width: '35%',
    },
    {
      title: i18n.t('modals.modalEditDistributionCenterOrderTimeSums.table.edit.title'),
      key: 'edit',
      width: '15%',
      render: (data) => {
        return (
          <React.Fragment>
            <Button htmlType="button" key="submitPrev" style={BackButtonStyle}
                    onClick={() => deleteOrderTimeSum(data.id)} type="danger">
              <Icon style={{position: "absolute", paddingTop: "3px", display: "flex"}} type="delete"
                    theme="filled"/> {i18n.t('main.buttons.delete')}
            </Button>
          </React.Fragment>
        );
      },
    },
  ];

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  return (
    <Modal
      title={<span>{i18n.t('modals.modalEditDistributionCenterOrderTimeSums.title', {name:name})}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal();
        setLoadingContentModal(true);
      }}
      width={1140}
      forceRender={true}
      footer={[
        <Button htmlType="submit" key="submit" type="primary" onClick={onClickAdd}
                style={bigButtonStyle}>{i18n.t('main.buttons.save')}</Button>,
      ]}
    >
      <Spinner loading={loadingContentModal} label={null}>
        <Row gutter={[16, 24]} style={{marginBottom: "54px"}}>
          <Col lg={10} md={12} sm={24} xs={24}>
            <InputField
              name="time" label={i18n.t('modals.modalEditDistributionCenterOrderTimeSums.fields.time.title')}
              value={time} setValue={setTime}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={10} md={12} sm={24} xs={24}>
            <InputField
              name="sum" label={i18n.t('modals.modalEditDistributionCenterOrderTimeSums.fields.sum.title')}
              value={sum} setValue={setSum}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={4} md={24} sm={24} xs={24}>
            <Button style={smallButtonStyle} htmlType="submit" key="submit" type="primary"
                    onClick={onClickAdd}>{i18n.t('main.buttons.save')}</Button>
          </Col>
        </Row>
        <Table
          style={{minWidth: '100%'}}
          columns={columns}
          className="distribution-centres-table"
          dataSource={timeAndSums}
          locale={{emptyText: i18n.t('main.empty')}}
          rowKey="id"
          size="small"
        />
      </Spinner>
    </Modal>
  );
}
